const textEncoder = new TextEncoder();

/** UTF-8 byte length of a string (for HTTP body/header octet counts). */
export function utf8ByteLength(str) {
  if (str == null || str === '') return 0;
  return textEncoder.encode(String(str)).length;
}

/**
 * Approximate wire size of a header block as `name: value\r\n` lines (UTF-8),
 * consistent with common HTTP client breakdowns.
 */
export function wireHeadersBytes(headers) {
  if (!headers || typeof headers !== 'object') return 0;
  let sum = 0;
  for (const [key, value] of Object.entries(headers)) {
    const v = Array.isArray(value) ? value.join(', ') : String(value ?? '');
    sum += utf8ByteLength(`${key}: ${v}\r\n`);
  }
  return sum;
}

/**
 * Human-readable size (B, KB, MB, …) using 1024-based units.
 * Bytes are integers; larger units use up to 2 fractional digits (trailing zeros trimmed).
 */
export function formatBytes(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(Math.floor(Math.log(n) / Math.log(1024)), units.length - 1);
  const value = n / 1024 ** i;
  if (i === 0) return `${Math.round(value)} B`;
  const rounded = Number(value.toFixed(2));
  return `${rounded} ${units[i]}`;
}
